@if (!hideButtons) {
  <div class="static-buttons-heading">
    {{ 'global.staticFooterButtonsHeading' | translate }}
  </div>
}

<div class="static-buttons-container">
  @if (!hideButtons) {
    @if (this.loggedUser.managementType === 'EXECUTION_ONLY') {
      <a class="button-container" [routerLink]="disableInvestmentCreation ? null : '/strategy/pick'">
        <libero-button
          label="{{ 'global.buttons.createStrategy' | translate }}"
          btnClasses="btn--primary btn--big"
          [disabledTooltipText]="disableInvestmentCreation ? 'liquidationDisabledStrategy' : null"
          [buttonDisabled]="disableInvestmentCreation"
        ></libero-button>
      </a>
    }
    <a class="button-container" [routerLink]="disableInvestmentCreation ? null : '/portfolio/new'">
      <libero-button
        label="{{ 'global.buttons.createPortfolio' | translate }}"
        btnClasses="btn--primary btn--big"
        [disabledTooltipText]="disableInvestmentCreation ? 'liquidationDisabledStrategy' : null"
        data-cy="static-footer-new-portfolio-button"
        [buttonDisabled]="disableInvestmentCreation"
      ></libero-button>
    </a>
  } @else {
    <div class="alternative-text">
      {{ 'global.buttonsAlternativeText' | translate }}
    </div>
  }

  <div class="consultation-button-container phone-content">
    <libero-button label="{{ 'global.buttons.consultation' | translate }}" (click)="openModal()" btnClasses="btn--icon-text icon--secondary" svgIcon="accountant"></libero-button>
  </div>
</div>

<div class="consultation-button-container desktop-content">
  <libero-button label="{{ 'global.buttons.consultation' | translate }}" (click)="openModal()" btnClasses="btn--icon-text icon--secondary" svgIcon="accountant"></libero-button>
</div>
